import { createSelector } from 'reselect'

import { selectGeneralReportsState } from './selectGeneralReportsState'

export const selectGeneralReportSelectedRtm = createSelector(
  [selectGeneralReportsState],
  ({ selectedRtm }) => selectedRtm
)
